import { siteInfo } from '@/mocks/data';
import Breadcrumb from '@/components/feature/Breadcrumb';

const aboutJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: siteInfo.name,
  url: 'https://yozakura-nav.example.com',
  description: siteInfo.description,
  foundingDate: siteInfo.founded,
  contactPoint: {
    '@type': 'ContactPoint',
    email: siteInfo.email,
    contactType: 'customer service',
  },
};

export default function AboutPage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutJsonLd) }}
      />
      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: '关于我们' },
          ]}
        />

        <section className="w-full px-4 md:px-6 lg:px-8 py-20 bg-background-50">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950 mb-4">
              关于 {siteInfo.name}
            </h1>
            <p className="text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
              {siteInfo.tagline}
            </p>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 lg:px-8 py-16 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-16">
              <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-article-line text-xl text-primary-600"></i>
                </div>
                <div className="text-2xl font-bold font-heading text-primary-500">{siteInfo.stats.articles}</div>
                <div className="text-sm text-foreground-500 mt-1">精选文章</div>
              </div>
              <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-price-tag-3-line text-xl text-accent-600"></i>
                </div>
                <div className="text-2xl font-bold font-heading text-accent-500">{siteInfo.stats.categories}</div>
                <div className="text-sm text-foreground-500 mt-1">风格分类</div>
              </div>
              <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-user-heart-line text-xl text-secondary-600"></i>
                </div>
                <div className="text-2xl font-bold font-heading text-secondary-500">{siteInfo.stats.visitors}</div>
                <div className="text-sm text-foreground-500 mt-1">累计访客</div>
              </div>
            </div>

            <div className="bg-background-50 border border-background-200/70 rounded-lg p-8 mb-8">
              <h2 className="text-xl font-bold font-heading text-foreground-950 mb-4">
                品牌介绍
              </h2>
              <div className="text-sm text-foreground-600 leading-relaxed space-y-4">
                <p>
                  {siteInfo.name}成立于{siteInfo.founded}年，是国内领先的里番动漫与漫画内容导航平台。我们致力于为成年动漫爱好者提供专业、全面的内容推荐与资讯服务，帮助用户在丰富的日本成人动漫作品中找到符合个人品味与兴趣的优质内容。
                </p>
                <p>
                  我们的编辑团队由资深的日本动漫文化研究者组成，每位成员都对里番动漫/漫画领域有着深入的理解与独到的见解。我们坚持以客观、专业的态度对每一部推荐作品进行分析与解读，力求为读者提供有价值的参考信息。
                </p>
                <p>
                  在内容选择上，我们遵循严格的筛选标准：不仅关注作品的制作质量与艺术水准，也重视作品的文化内涵与叙事价值。我们认为，优秀的里番动漫/漫画应当在满足成人内容需求的同时，具备完整的故事结构、立体的人物塑造和独特的艺术表达。
                </p>
                <p>
                  {siteInfo.name}始终坚持合规运营原则。我们自身不提供任何里番动漫/漫画内容的下载或在线观看服务，而是作为信息导航平台，为读者指引正规合法的内容获取渠道。我们倡导在法律法规和年龄限制框架内理性消费成人内容，支持正版创作，促进行业健康发展。
                </p>
              </div>
            </div>

            <div className="bg-background-50 border border-background-200/70 rounded-lg p-8 mb-8">
              <h2 className="text-xl font-bold font-heading text-foreground-950 mb-4">
                口碑与影响力
              </h2>
              <div className="text-sm text-foreground-600 leading-relaxed space-y-4">
                <p>
                  自成立以来，{siteInfo.name}凭借专业的内容筛选能力与深度的文化解读视角，在里番动漫爱好者群体中建立了良好的口碑。我们的文章被多家动漫社区与论坛引用转载，累计服务了超过{siteInfo.stats.visitors}用户。
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6">
                  <div className="border border-background-200/70 rounded-lg p-5">
                    <div className="flex items-center gap-1 text-accent-500 mb-2">
                      <i className="ri-star-fill text-xs"></i>
                      <i className="ri-star-fill text-xs"></i>
                      <i className="ri-star-fill text-xs"></i>
                      <i className="ri-star-fill text-xs"></i>
                      <i className="ri-star-fill text-xs"></i>
                    </div>
                    <p className="text-xs text-foreground-500 leading-relaxed">
                      "夜桜导航是我了解里番文化的首选平台，文章质量很高，分类清晰，推荐的渠道也很靠谱。"
                    </p>
                    <p className="text-xs text-foreground-400 mt-2">—— 资深动漫爱好者</p>
                  </div>
                  <div className="border border-background-200/70 rounded-lg p-5">
                    <div className="flex items-center gap-1 text-accent-500 mb-2">
                      <i className="ri-star-fill text-xs"></i>
                      <i className="ri-star-fill text-xs"></i>
                      <i className="ri-star-fill text-xs"></i>
                      <i className="ri-star-fill text-xs"></i>
                      <i className="ri-star-fill text-xs"></i>
                    </div>
                    <p className="text-xs text-foreground-500 leading-relaxed">
                      "内容深度和专业度在同类平台中出类拔萃，对日本成人动漫文化的解读非常到位。"
                    </p>
                    <p className="text-xs text-foreground-400 mt-2">—— 动漫文化研究者</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-background-50 border border-background-200/70 rounded-lg p-8">
              <h2 className="text-xl font-bold font-heading text-foreground-950 mb-4">
                联系我们
              </h2>
              <div className="text-sm text-foreground-600 leading-relaxed space-y-3">
                <p>
                  我们欢迎读者通过以下方式与我们取得联系。无论是对网站内容的建议、合作意向，还是对里番动漫文化的探讨，我们都期待与您交流。
                </p>
                <div className="flex items-center gap-3 mt-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100">
                    <i className="ri-mail-line text-primary-600"></i>
                  </div>
                  <div>
                    <span className="text-xs text-foreground-400">电子邮箱</span>
                    <p className="text-sm font-medium text-foreground-800">{siteInfo.email}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 mt-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100">
                    <i className="ri-map-pin-line text-accent-600"></i>
                  </div>
                  <div>
                    <span className="text-xs text-foreground-400">办公地址</span>
                    <p className="text-sm font-medium text-foreground-800">上海市浦东新区张江高科技园区</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}